import React, { Fragment, memo } from 'react';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { ListItemText, IconButton, MenuItem } from '@mui/material';
import GearIcon from '@mui/icons-material/Settings';
import Popover from '@mui/material/Popover';
import { Link as RouterLink } from 'react-router-dom';

const PREFIX = 'GearMenu';

const classes = {
  topBarIcon: `${PREFIX}-topBarIcon`,
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')(({ theme }) => ({
  [`& .${classes.topBarIcon}`]: {
    marginRight: '8px',
  },
}));

const GearMenu = props => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleMenuOpen = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(undefined);
  };

  return (
    <Root>
      <IconButton
        {...props}
        className={classes.topBarIcon}
        onClick={handleMenuOpen}
        size='small'
        color='inherit'
        data-test-id='top-gear-menu'
      >
        <GearIcon />
      </IconButton>
      <Popover
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        classes={{ paper: classes.menu }}
        onClose={handleMenuClose}
        onClick={handleMenuClose}
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
      >
        <RouterLink to='/meetup'>
          <MenuItem sx={{ py: 1, px: 2, my: '4px' }}>
            <ListItemText primary='Мероприятия' />
          </MenuItem>
        </RouterLink>
        <RouterLink to='/badge'>
          <MenuItem sx={{ py: 1, px: 2, my: '4px' }}>
            <ListItemText primary='Шаблоны документов' />
          </MenuItem>
        </RouterLink>
        <RouterLink to='/user'>
          <MenuItem sx={{ py: 1, px: 2, my: '4px' }}>
            <ListItemText primary='Администраторы' />
          </MenuItem>
        </RouterLink>
        <RouterLink to='/mail-domain'>
          <MenuItem sx={{ py: 1, px: 2, my: '4px' }}>
            <ListItemText primary='Настройки почты' />
          </MenuItem>
        </RouterLink>
      </Popover>
    </Root>
  );
};

GearMenu.propTypes = {
  className: PropTypes.string,
};

export default memo(GearMenu);
